import { FreightPickupAccessorialPresetRowSchema } from "@redotech/redo-fulfillment-common/freight/freight-pickup-accessorial-preset";
import * as z from "zod";

export const getFreightPickupAccessorialPresets = {
  name: "getFreightPickupAccessorialPresets" as const,
  input: z.object({}),
  output: z.object({
    presets: z.array(FreightPickupAccessorialPresetRowSchema),
  }),
};
